import React from 'react'
import Button from '../../blocks/Button';
import pluralise from '../../util/pluralise';

export default function BadgingControls(props) {
  const {
    awardableBadges,
    printableBadges,
    selectedRows,
    onAwardBadges,
    onPrintBadges,
    buildCertificates,
    waiting,
  } = props;
  
  return (
    <div className='badgingControls'>
      <Button
        onClick={onAwardBadges}
        disabled={awardableBadges.length === 0}
        waiting={waiting}
      >
        Award {awardableBadges.length} {pluralise('Badge', awardableBadges.length > 1)}
      </Button>
      <Button
        onClick={onPrintBadges}
        disabled={printableBadges.length === 0}
      >
        Print {printableBadges.length} {pluralise('Certificate', printableBadges.length > 1)}
      </Button>
      <Button
        onClick={buildCertificates}
        disabled={selectedRows.length === 0}
      >
        Build Certificates
      </Button>
    </div>
  )
}